export const KONWLEDGE_BASE_URL = {
  TOOLTIP:
    'https://knowledge-base.yieldbird.com/prebid-stack/amazon-uamtam#block-05042ec043954f608a829600b2ce530a',
} as const
